import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { CONTRACTS__VIEW_DETAILS } from 'translations/constants';

interface ViewDetailsButtonProps {
  isHovered: boolean;
  onClick?: () => void;
}

const DetailsLink = styled('button')({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 600,
  padding: '4px 8px',
  textDecoration: 'underline',
  fontFamily: "'Montserrat', sans-serif",
  '&:hover': {
    color: '#006B10',
  },
});

const ViewDetailsButton = (props: ViewDetailsButtonProps) => {
  const { isHovered, onClick } = props;
  const { t } = useTranslation();

  if (!isHovered) {
    return null;
  }

  return (
    <DetailsLink type="button" onClick={onClick}>
      {t(CONTRACTS__VIEW_DETAILS)}
    </DetailsLink>
  );
};

ViewDetailsButton.defaultProps = {
  onClick: undefined,
};

export default ViewDetailsButton;
